import styled from 'styled-components';
import InternalReference from './InternalReference';

export default styled(InternalReference)``;
